import script from "./specialPromotion.vue?vue&type=script&setup=true&name=specialPromotion&lang=js"
export * from "./specialPromotion.vue?vue&type=script&setup=true&name=specialPromotion&lang=js"

import "./specialPromotion.vue?vue&type=style&index=0&id=7de5ddd2&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7de5ddd2"]])

export default __exports__